// extracted by mini-css-extract-plugin
module.exports = {"section":"Hero_section__23Jfr","body":"Hero_body__3ipvL","text":"Hero_text__2IN_D","buttons":"Hero_buttons__ofS9m","image":"Hero_image__2I78B"};